function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.64124 15.6412C2.53204 14.7504 3.74022 14.25 5 14.25H13C14.2598 14.25 15.468 14.7504 16.3588 15.6412C17.2496 16.532 17.75 17.7402 17.75 19V21C17.75 21.4142 17.4142 21.75 17 21.75C16.5858 21.75 16.25 21.4142 16.25 21V19C16.25 18.138 15.9076 17.3114 15.2981 16.7019C14.6886 16.0924 13.862 15.75 13 15.75H5C4.13805 15.75 3.3114 16.0924 2.7019 16.7019C2.09241 17.3114 1.75 18.138 1.75 19V21C1.75 21.4142 1.41421 21.75 1 21.75C0.585786 21.75 0.25 21.4142 0.25 21V19C0.25 17.7402 0.750445 16.532 1.64124 15.6412Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 3.75C7.20507 3.75 5.75 5.20507 5.75 7C5.75 8.79493 7.20507 10.25 9 10.25C10.7949 10.25 12.25 8.79493 12.25 7C12.25 5.20507 10.7949 3.75 9 3.75ZM4.25 7C4.25 4.37665 6.37665 2.25 9 2.25C11.6234 2.25 13.75 4.37665 13.75 7C13.75 9.62335 11.6234 11.75 9 11.75C6.37665 11.75 4.25 9.62335 4.25 7Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.2738 14.9426C19.3773 14.5415 19.7864 14.3003 20.1874 14.4039C21.2065 14.667 22.1093 15.2611 22.7541 16.0929C23.3989 16.9247 23.7492 17.9471 23.7499 18.9995L23.7499 21.0001C23.7499 21.4143 23.4142 21.7501 22.9999 21.7501C22.5857 21.7501 22.2499 21.4143 22.2499 21.0001L22.2499 19.0006C22.2499 19.0005 22.2499 19.0007 22.2499 19.0006C22.2493 18.2806 22.0097 17.5809 21.5685 17.0119C21.1274 16.4428 20.5097 16.0363 19.8124 15.8562C19.4114 15.7527 19.1702 15.3436 19.2738 14.9426Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2734 2.94405C15.3761 2.54278 15.7847 2.30077 16.186 2.40352C17.2077 2.66512 18.1133 3.25935 18.76 4.09251C19.4068 4.92567 19.7578 5.95038 19.7578 7.00508C19.7578 8.05978 19.4068 9.08449 18.76 9.91765C18.1133 10.7508 17.2077 11.345 16.186 11.6066C15.7847 11.7094 15.3761 11.4674 15.2734 11.0661C15.1706 10.6648 15.4126 10.2563 15.8139 10.1535C16.513 9.97452 17.1326 9.56795 17.5751 8.99789C18.0176 8.42783 18.2578 7.72672 18.2578 7.00508C18.2578 6.28344 18.0176 5.58233 17.5751 5.01227C17.1326 4.44221 16.513 4.03564 15.8139 3.85664C15.4126 3.7539 15.1706 3.34532 15.2734 2.94405Z",
  fill: "currentColor"
});

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.a187b479.svg";
export { ForwardRef as ReactComponent };